class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);


      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    okeWidgetApi.initAllWidgets();
    autoOpenFreeProductModal();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }


  renderContents(parsedState, isFromBundleBuilder, productsIdList) {
    // console.log('din rerender contents')
    // console.log('@---------> productsIdList', productsIdList)

    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (window.innerWidth < 991 && document.querySelector('.atc-mini-notification') && !(window.location.href.includes('cart'))) {
      // console.log('@-> open mobile modal add to cart notification')

      // if (productsIdList.length > 1) {
      //   console.log('multiple added products', parsedState.items)

      //   //get data and update modal
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   // itemsContainer.innerHTML = ``;

      //   parsedState.items.forEach(item => {
      //     itemsContainer.innerHTML += `
      //     <div class="atc-notification-modal__item-wrapper">
      //       <div class="item-image"><img src="${item.featured_image.url}" alt=""></div>
      //       <div class="item-main-details">
      //         <p class="item-title">${item.title}</p>
      //         <p class="item-price">C$${(item.final_price / 100).toFixed(2)}</p>
      //       </div>
      //       <div class="item-extra-details">
      //         <p>Eau de Parfum. Size: 50ml / 1.7oz</p>
      //       </div>
      //     </div>
      //     `
      //   })
      // }
      // else {
      //   console.log('single added product')
      //   let itemsContainer = document.querySelector('.atc-notification-modal__items');

      //   //get data and update modal

      //   let currentProduct = {
      //     id: productsIdList[0],
      //     img_src: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__image`)?.src,
      //     title: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__name`).textContent,
      //     price: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`) ? document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .cart-item__new-price`)?.textContent : document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"] .cart-item__price-wrapper .price`)?.textContent,
      //     // inspired_by: document.querySelector(`.drawer .cart-item[data-product-id="${productsIdList[0]}"]  .cart-item__details p:not(.product-option)`)?.textContent,
      //   }

      //   // itemsContainer.innerHTML = ``;

      //   itemsContainer.innerHTML = `
      //    <div class="atc-notification-modal__item-wrapper">
      //       <div class="item-image"><img src="${currentProduct.img_src}" alt=""></div>
      //       <div class="item-main-details">
      //         <p class="item-title">${currentProduct.title}</p>
      //         <p class="item-price">${currentProduct.price}</p>
      //       </div>
      //       <div class="item-extra-details">
      //         <p>Eau de Parfum. Size: 50ml / 1.7oz</p>
      //       </div>
      //     </div>
      //   `;
      // }

      // //qty calc

      // let qty = document.querySelector('[data-cart-qty]').dataset.cartQty;
      // let pills = document.querySelectorAll('.atc-notification-modal__progress-bar-wrapper .progress-bar-v2 .pill')

      // pills.forEach((pill, index) => {
      //   console.log('index', index)
      //   if (index < qty) {
      //     pill.classList.add('active')
      //   }
      //   else {
      //     pill.classList.remove('active')
      //   }
      // })

      // Show mini notification instead of modal
      if (document.querySelector('.drawer:not(.active)')) {

        if (!document.querySelector(".cart-free-product_container--main_product .cart-item") && document.querySelector("body.crmOfferON") && document.querySelector('[data-cart-qty]').dataset.cartQty >= 2) {
          console.log('show free product modal!!')
          document.querySelector('#free-product-modal-gift').classList.toggle('show');
        }
        else {

          document.dispatchEvent(new CustomEvent('product:added-to-cart'));
        }
      }

    }
    else {
      if (isFromBundleBuilder) {
        console.log('added item from bundle builder')
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          // this.open();
        });

        showDynamicPrices();
      }
      else if (window.location.href.includes('cart')) {
        console.log("product added din cart page")
      }
      else {
        setTimeout(() => {
          this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
          this.open();
        });
      }
    }


  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'header-bottom-island',
        section: 'header-bottom-island',
        selector: '.header__bottom-island',
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'header-bottom-island',
        section: 'header-bottom-island',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);